export default __webpack_public_path__ + "static/media/coddi.4600f62d.png";